import { Component, computed, inject, input, signal } from '@angular/core';
import { PlayerService } from '../../data-access/player.service';
import { SkinningService } from '@core/skin';
import { CommonModule } from '@angular/common';
import { TranscodeImageDirective } from '@shared/directives/transcode-image.directive';
import { TranslocoPipe } from '@jsverse/transloco';
import { RoundedIconButton } from 'app/shared/components/rounded-icon-button/rounded-icon-button';

@Component({
  selector: 'player-binge',
  imports: [
    CommonModule,
    RoundedIconButton,
    TranscodeImageDirective,
    TranslocoPipe
  ],
  templateUrl: './player-binge.component.html',
  styleUrl: './player-binge.component.scss'
})
export class PlayerBingeComponent {
  private playerService = inject(PlayerService);
  public skinning = inject(SkinningService);
  public nextItem = input(null);

  public isMiniPlayer = signal(false);
  public isUiHidden = signal(false);

  public nextItemTitle = computed(() => {
    const nextItem = this.nextItem();
    if (!nextItem) return '';
    return `S${nextItem.seasonNumber}:E${nextItem.episodeNumber || '1'} ${nextItem.title}`;
  });
  /**
   * Seconds left in the current item, or null while there is no real length to measure
   * against. Duration comes straight off the playback engine rather than from a signal, and
   * it reads 0 (or NaN) between loading a source and its first `timeupdate`, and Infinity on
   * live. Subtracting a position from those and clamping at 0 says "no time left" for a clip
   * that has not started - which is what pulled the card back over the next episode.
   */
  private secondsRemaining = computed<number | null>(() => {
    const progress = this.playerService.getProgress()();
    const duration = this.playerService.getDuration();
    if (!Number.isFinite(duration) || duration <= 0) return null;
    return Math.max(Math.floor(duration - progress), 0);
  });
  public nextItemCountdown = computed(() => this.secondsRemaining() ?? 0);
  public displayBinge = computed(() => {
    const remaining = this.secondsRemaining();
    return remaining !== null && remaining <= 10 && !!this.nextItem() && !this.playerService.isNextItemDismissed();
  });

  playNextItem() {
    this.playerService.playNextItem();
  }

  closeBinge(event: MouseEvent) {
    // The close button sits inside the card, whose own click plays the next item.
    event.stopPropagation();
    this.playerService.dismissNextItem();
  }

}
